export default "__VITE_ASSET__87307d50__"